import identityApiClient from '../../../services/identity-api-client'

export interface PermissionUser {
  id: string
  loginId: string
  loginName: string
  email: string
  sysPermissionId: string
  tenantCode: string
  action: string
}

export interface GrantPermissionRequest {
  loginId: string
  sysPermissionId: string
  tenantCode: string
  action: string
}

export async function getPermissionUsers(tenantCode: string, sysPermissionId: string): Promise<PermissionUser[]> {
  const response = await identityApiClient.get<PermissionUser[]>(
    `/api/login/permission/${tenantCode}/${sysPermissionId}`
  )
  return response.data
}

export async function grantPermission(request: GrantPermissionRequest): Promise<void> {
  await identityApiClient.post('/api/login/permission/grant', request)
}

export async function revokePermission(id: string): Promise<void> {
  await identityApiClient.delete(`/api/login/permission/${id}`)
}
